export default class Map {
    constructor(component) {
        this.component = component;
        this.key = this.component.getAttribute('data-map-key');
        this.hasform = this.component.getAttribute('data-map-hasform');
        this.centerLat = this.component.getAttribute('data-map-center-lat');
        this.centerLng = this.component.getAttribute('data-map-center-lng');
        this.locations = JSON.parse(
            this.component.getAttribute('data-map-locations')
        );
        this.markers = [];

        if (!this.key) return;

        this.centerLat = parseFloat(this.centerLat);
        this.centerLng = parseFloat(this.centerLng);

        this.init();
    }

    // Prettier-ignore
    loadMap(root) {
        root.map = new google.maps.Map(root.component, {
            center: {
                lat: root.centerLat ? root.centerLat : 52.090736,
                lng: root.centerLng ? root.centerLng : 5.121420
            },
            zoom: root.centerLat ? 15 : 5,
            disableDefaultUI: true
        });

        root.map.addListener('center_changed', () => {
            window.setTimeout(() => {
                if (!root.map.getBounds().contains(root.currentMarker.getPosition())) {
                    this.infobox.classList.add('is-hidden');
                }
            }, 100);
        });
    }

    loadMarkers(root) {
        root.locations.map((location, i) => {
            const marker = new google.maps.Marker({
                position: new google.maps.LatLng(location.lat, location.lng),
                map: root.map
            });

            this.markers.push(marker);

            if (i === 0) root.currentMarker = marker;

            google.maps.event.addListener(marker, 'click', function() {
                root.setInfoboxContent(root, location);
                root.currentMarker = marker;
                root.map.panTo(marker.getPosition());
                root.infobox.classList.remove('is-hidden');
            });
        });
    }

    setInfoboxContent(root, location) {
        root.infobox.innerHTML = `
            <img class="card__image" src="${location.image}">
            <div class="card__body">
                ${
            location.label !== null
                ? '<small class="font-flama font-weight-600 d-block">' +
                location.label +
                '</small>'
                : ''
        }
                <p><b>${location.title}</b></p>
                <p class="color-blue-transparent">${location.address}</p>
            </div>
            <a href="${
    location.linkUrl
}" target="_blank" rel="noopener noreferrer" class="link link--small"><svg class="fill-green" width="20" height="10"><use xlink:href="#icon-arrow"></use></svg><span>${
    location.linkText
}</span></a>
        `;
    }

    loadInfobox(root) {
        const container = document.createElement('div');
        if(root.hasform === 'False') {
            container.classList.add('container');
        }
        container.style.pointerEvents = 'none';

        root.infobox = document.createElement('div');
        root.infobox.classList.add('card');
        root.setInfoboxContent(root, root.locations[0]);

        root.component.appendChild(container);
        container.appendChild(root.infobox);
    }

    initExternalTriggers(root) {
        document.querySelectorAll('[data-map-link]').forEach(trigger => {
            trigger.addEventListener('click', () => {
                const reference = trigger.getAttribute('data-map-link').split('/');
                const markerToClick = root.markers.filter(marker => {
                    if (
                        marker.internalPosition.lat().toString() === reference[0] &&
            marker.internalPosition.lng().toString() === reference[1]
                    ) {
                        return marker;
                    }
                });

                if (!markerToClick) return;

                new google.maps.event.trigger(markerToClick[0], 'click');
            });
        });
    }

    init() {
        const root = this;
        const script = document.createElement('script');

        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.key}&callback=loadMap`;
        script.defer = true;

        window.loadMap = function() {
            root.loadMap(root);
            root.loadMarkers(root);
            root.loadInfobox(root);
            root.initExternalTriggers(root);
        };

        document.head.appendChild(script);
    }
}
